import Icon from "@material-ui/icons/SupervisedUserCircle";
import CustomerCardList from "./CustomerCardList";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "customerCards",
  list: CustomerCardList,
  icon: Icon,
};
